import { createApp } from 'vue'
import { firebaseError } from './firebase/firebaseConfig'
import App from './App.vue'
import FirebaseError from './components/FirebaseError.vue'
import router from './routes/index.js'
import { clickable } from './directives/clickable'
import 'bootstrap-icons/font/bootstrap-icons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '@/assets/styles/main.css'

import { prefs }          from '@/services/cookieService'
import { lsPurgeExpired } from '@/services/cacheService'

const savedTheme = prefs.getTheme() !== 'light'
  ? prefs.getTheme()
  : (() => {
      try {
        const admin = JSON.parse(localStorage.getItem('aerj_admin_settings') || '{}')
        const user  = JSON.parse(localStorage.getItem('aerj_settings') || '{}')
        return (admin.darkMode || user.darkMode) ? 'dark' : 'light'
      } catch { return 'light' }
    })()

document.documentElement.setAttribute('data-theme', savedTheme)

lsPurgeExpired()

const RootComponent = firebaseError ? FirebaseError : App

const app = createApp(RootComponent)
app.use(router)
app.directive('clickable', clickable)
app.mount('#app')
